import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  title: string;
}

const LayoutContainer = styled.div`
  min-height: 100vh;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
`;

const MainWrapper = styled.div`
  flex: 1;
  margin-left: 80px;
  transition: margin-left 0.3s ease;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  &.sidebar-open {
    margin-left: 280px;
  }

  @media (max-width: 768px) {
    margin-left: 0;

    &.sidebar-open {
      margin-left: 0;
    }
  }
`;

const MainContent = styled.main`
  flex: 1;
  padding-top: 64px;
`;

const ContentArea = styled.div`
  padding: 24px;
  max-width: 100%;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

const Layout: React.FC<LayoutProps> = ({ children, title }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      <MainWrapper className={sidebarOpen ? 'sidebar-open' : undefined}>
        <Header onMenuToggle={toggleSidebar} title={title} />
        <MainContent>
          <ContentArea>
            {children}
          </ContentArea>
        </MainContent>
        <Footer />
      </MainWrapper>
    </LayoutContainer>
  );
};

export default Layout;
